export interface ISurgeryKitHeader {
    surgeryKitHeaderId: number;
    kitName: string;
    createdBy: number;
    createdDate: Date;
    modifiedDate?: Date;
    createdByName: string;
    isShow: boolean;
    createdByRole: string;
    modifiedByName: string;
    modifiedByRole: string;
}